// extracted by mini-css-extract-plugin
export default {"container":"style_container__6cZhZ","bg":"style_bg__Akz9w"};